export const INITIATIVES_TABLE_KEYS = {
	ASSIGNED_TO: 'assignedTo',
	CREATED_ON: 'createdOn',
	DETAILS: 'details',
	STATUS: 'status',
	TITLE: 'title',
	TYPE: 'type'
};
